import { useStore } from '../state/store';
import { BankArea, RecordTable } from './BankArea';
import { Badge, formatMoney } from '../design/primitives';

export function Lending() {
  const { bootstrap } = useStore();
  if (!bootstrap) return null;
  const { loans, customers } = bootstrap.records;

  const nameOf = (customerId: string) =>
    customers.find((customer: any) => customer.id === customerId)?.name ?? customerId;

  return (
    <BankArea
      serverName={['sme-lending-mcp', 'agro-lending-mcp']}
      lede="Two lending desks share one pattern: agents may read credit files and prepare decisions, but they may not override underwriting. Reading is delegable; deciding is not."
    >
      <RecordTable
        title="Loan applications"
        columns={[
          { key: 'id', label: 'Application' },
          { key: 'customer', label: 'Customer' },
          { key: 'kind', label: 'Facility' },
          { key: 'amount', label: 'Requested', align: 'right' },
          { key: 'maturity', label: 'Maturity' },
          { key: 'status', label: 'Status' },
        ]}
        rows={loans.map((loan: any) => ({
          id: <code className="mb-mono">{loan.id}</code>,
          customer: nameOf(loan.customerId),
          kind: loan.kind,
          amount: <span className="mb-numeric">{formatMoney(loan.requestedAmountRon)}</span>,
          maturity: loan.maturity,
          status: (
            <Badge tone={loan.status === 'approved' ? 'allow' : loan.status === 'declined' ? 'block' : 'approval'}>
              {loan.status.replace('_', ' ')}
            </Badge>
          ),
        }))}
      />
    </BankArea>
  );
}
